import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import FavouriteJourneyViewModel from "@/models/FavouriteJourneyViewModel";
export default function () {

    const saveFavouriteJourney = async (
        model: FavouriteJourneyViewModel
    ): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.post("/api/favouriteJourney", model)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const updateFavouriteJourney = async (
        model: FavouriteJourneyViewModel
    ): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/favouriteJourney/${model.id}`, model)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        console.log("Success update journey");
                        resolve();
                    } else {
                        console.log("Error update journey");
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const getFavouriteJourney = async (
        id: number
    ): Promise<FavouriteJourneyViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/favouriteJourney/${id}`)
                .then((result: AxiosResponse<FavouriteJourneyViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const deleteFavouriteJourney = async (id: number): Promise<void> => {
        await defineHeaderAxios();

        return new Promise((resolve, reject) => {
            Axios.delete(`/api/favouriteJourney/${id}`)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    return {
        saveFavouriteJourney,
        updateFavouriteJourney,
        getFavouriteJourney,
        deleteFavouriteJourney,
    };
}
